import { createI18n } from 'vue-i18n'

import messagesCs from './messages_cs'
import messagesEn from './messages_en'
import messagesEl from './messages_el'

import moment from 'moment'
import { csPluralizationRule } from './pluralization'

const getDefaultLanguage = () => {
    switch (window.location.hostname) {
    case 'app.chytrevodomery.cz':
        return 'cs'
    case 'app.wateradmin.com':
        return 'en'
    default:
        return 'en'
    }
}

const lang = localStorage.getItem('language')
let defaultLanguage = getDefaultLanguage()
if (lang == null) {
    localStorage.setItem('language', JSON.stringify(defaultLanguage))
}
defaultLanguage = lang == null ? defaultLanguage : JSON.parse(lang)

moment.locale(defaultLanguage)

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: defaultLanguage,
    fallbackLocale: 'en',
    pluralizationRules: {
        cs: csPluralizationRule
    },
    messages: {
        cs: messagesCs,
        en: messagesEn,
        el: messagesEl
    }
})

export default i18n
